import axios from 'axios'

const {
  VUE_APP_API_SERVER
} = process.env

const saveDetails = async (_data) => {
  const result = await axios
    .post(`${VUE_APP_API_SERVER}/cons-bio/survey/answerdetails`, _data)
    .catch(function (error) {
      error.Error = true
      return error
    })
  return result
}

const getDetails = async (_id) => {
  const result = await axios
    .get(`${VUE_APP_API_SERVER}/cons-bio/survey/gardenrecord/${_id}`)
    .catch(function (error) {
      error.Error = true
      return error
    })
  return result
}
const saveTF50Details = async (_data) => {
  const result = await axios
    .post(`${VUE_APP_API_SERVER}/cons-bio/survey/tf50/answerdetails`, _data)
    .catch(function (error) {
      error.Error = true
      return error
    })
  return result
}

const getTF50Details = async (_id) => {
  const result = await axios
    .get(`${VUE_APP_API_SERVER}/cons-bio/survey/tf50/record/${_id}`)
    .catch(function (error) {
      error.Error = true
      return error
    })
  return result
}

const saveRegentDetails = async (_data) => {
  const result = await axios
    .post(`${VUE_APP_API_SERVER}/cons-bio/survey/regent/answerdetails`, _data)
    .catch(function (error) {
      error.Error = true
      return error
    })
  return result
}

export {
  saveDetails,
  getDetails,
  saveTF50Details,
  getTF50Details,
  saveRegentDetails
}
